import React, { useState } from 'react'
import { useConfig } from '../../../contexts/ConfigContext';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from '../../Shared/Buttons'
import { DeliveryModal } from '../../DeliveryLocation/DeliveryModal'
import { Modal } from '../../Shared/Modal'
import { useOrder } from '../../../contexts/OrderContext'
import { useCart } from '../../../contexts/CartContext'
import { useCurrentVendor } from '../../../hooks/useCurrentVendor'
import { getVendorMinOrder } from '../../../utils/vendor'
import { formatPrice } from '../../../utils/formatPrice'

import {
  ReiviewCartContainer,
  ReviewCart,
  CountPrice,
  ReveiwCount,
  OrderErrorModalWrapper,
  ErrorText,
  ActionGroup,
} from './styles'
export const ReiviewCart = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [configState] = useConfig()
  const [orderDetail] = useOrder();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMinOrderModal, setIsMinOrderModal] = useState(false);
  const [cart] = useCart();
  const vendor = useCurrentVendor();

  const totalCount = cart.reduce((sum, item) => sum + item.count, 0);
  const totalAmount = cart.reduce((sum, item) => sum + item.count * (item.price || 0), 0);
  const minOrder = getVendorMinOrder(vendor, configState?.configs?.minimumAmount);
  const closeHandleClick = () => {
    setIsModalOpen(false)
  }

  const goOrder = () => {
    if (totalAmount < minOrder) {
      setIsMinOrderModal(true)
      return
    }
    history.push("/order");
  }

  const MinOrderModal = (
    <OrderErrorModalWrapper>
      <ErrorText>{t('Minimum Order Error').replace('_attribute_', `${minOrder} ${t(configState?.configs?.currency)}`)}</ErrorText>
      <ActionGroup>
        <Button color="primary" width="100px" onClick={() => setIsMinOrderModal(false)}>
          {t('Ok')}
        </Button>
      </ActionGroup>
    </OrderErrorModalWrapper>
  )
  return (
    <ReiviewCartContainer>
      {!orderDetail.currentLocation && cart?.length <= 0
        ? <Button color="primary" width="100%" uppercase={true} onClick={() => setIsModalOpen(true)}>
          {t('Start Ordering')}
        </Button>
        : cart?.length > 0
          ? <Button
            uppercase
            color='primary'
            width="100%"
            onClick={() => { !orderDetail.currentLocation ? setIsModalOpen(true) : goOrder() }}
          >
            <ReviewCart style={{ display: 'flex' }}>
              <CountPrice>
                <ReveiwCount>
                  {totalCount}
                </ReveiwCount>
                {`${formatPrice(totalAmount)} ${t(configState?.configs?.currency)}`}
              </CountPrice>
              <span>{t('Review Cart')}</span>
            </ReviewCart>
          </Button>
          : ''
      }
      {isModalOpen && <DeliveryModal closeHandleClick={closeHandleClick} />}
      <Modal
        open={isMinOrderModal}
        children={MinOrderModal}
        onClose={() => setIsMinOrderModal(false)}
        width="400px"
        isHideCloseIcon
      />
    </ReiviewCartContainer>  )
}